import {defineSlotRecipe} from '@chakra-ui/react3'

/**
 * recipe for Heading:
 * slots: root, subline, headline, headline1, headline2
 * variants:
 *  - alignment: left | center | inherit
 *  - dualTone: true | false
 *  - separateLines: true | false
 *  - variant: default | awards | hero | hidden
 */

export default defineSlotRecipe({
    slots: ['root', 'subline', 'headline', 'headline1', 'headline2'],
    base: {
        root: {
            display: 'flex',
            flexDirection: 'column',
            rowGap: 6,
            color: 'text.primary'
        },
        headline: {display: 'block'},
        subline: {
            color: 'text.brand-default',
            textStyle: 'labels.mediumCaps'
        }
    },
    variants: {
        alignment: {
            left: {
                root: {textAlign: 'start'}
            },
            center: {
                root: {textAlign: 'center'}
            },
            inherit: {
                root: {textAlign: 'inherit'}
            }
        },
        dualTone: {
            true: {
                headline1: {color: 'text.primary'},
                headline2: {color: 'text.secondary'}
            }
        },
        separateLines: {
            true: {
                headline1: {display: 'block'},
                headline2: {display: 'block'}
            },
            false: {
                headline1: {display: 'inline'},
                headline2: {display: 'inline'}
            }
        },
        variant: {
            // designed based on awards module - https://www.figma.com/design/54EbshuMlvuqCBKFYoAhHg/STOKKE-Design-System?node-id=1345-10304&m=dev
            awards: {
                root: {
                    textStyle: 'heading.large'
                },
                subline: {display: 'none'},
                headline1: {textStyle: 'heading.large'},
                headline2: {display: 'none'}
            },
            default: {
                root: {}
            },
            // designed based on hero module - https://www.figma.com/design/54EbshuMlvuqCBKFYoAhHg/STOKKE-Design-System?node-id=1940-13640&m=dev
            hero: {
                root: {
                    textStyle: 'display.largeItalic',
                    color: 'text.on-media.primary'
                }
            },
            hidden: {
                root: {
                    position: 'absolute',
                    width: '1px',
                    height: '1px',
                    padding: '0',
                    margin: '-1px',
                    overflow: 'hidden',
                    clip: 'rect(0, 0, 0, 0)',
                    whiteSpace: 'nowrap',
                    borderWidth: '0'
                }
            }
        },
        headlineSize: {
            small: {
                root: {
                    textStyle: 'display.small'
                }
            },
            medium: {
                root: {
                    textStyle: 'display.medium'
                }
            },
            large: {
                root: {
                    textStyle: 'display.large'
                }
            }
        }
    },
    defaultVariants: {
        alignment: 'left',
        dualTone: 'true',
        separateLines: 'true',
        variant: 'default',
        headlineSize: 'small'
    }
})
